import { Article } from 'helpCenter/types'
import { authorizedGet } from '.'
export type GetArticleProps = {
  articleId: string
}

export async function getArticle({
  articleId,
}: GetArticleProps): Promise<Article> {
  try {
    const response = await authorizedGet({ endpoint: `articles/${articleId}` })
    const article = (await response.json()) as Article
    return article
  } catch (e) {
    throw e
  }
}
